/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react'
import { connect } from 'react-redux'
import _, {
  debounce,
  get,
  has,
  pickBy,
  identity,
  pick,
  isEqual,
  uniq,
  omit,
} from 'lodash'
import qs from 'qs'
import PerfectScrollbar from 'react-perfect-scrollbar'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import moment from 'moment'
import { Helmet } from 'react-helmet'
import {
  Button,
  Row,
  Spin,
  Dropdown,
  Menu,
  Checkbox,
  Modal as AntdModal,
} from 'antd'
import Modal from 'react-responsive-modal'
import {
  withWindowSizes,
  FlexContainer,
  notification,
  EduIf,
  EduThen,
  EduElse,
  EduButton,
} from '@edulastic/common'
import {
  IconList,
  IconTile,
  IconTestBank,
  IconFilter,
  IconHamburger,
  IconClose,
} from '@edulastic/icons'
import {
  white,
  greyLight1,
  themeColor,
  greyThemeDark4,
  greyThemeLight,
  accessibilityColors,
  mobileWidthLarge,
  greyThemeDark1,
} from '@edulastic/colors'
import {
  storeInLocalStorage,
  getFromSessionStorage,
} from '@edulastic/api/src/utils/Storage'
import { libraryFilters, roleuser, sortOptions } from '@edulastic/constants'
import { withNamespaces } from 'react-i18next'
import {
  LIBRARY_TYPES,
  sessionFilters as sessionFilterKeys,
  sessionFilters,
} from '@edulastic/constants/const/common'

import produce from 'immer'
import { SMART_FILTERS } from '@edulastic/constants/const/filters'
import styled from 'styled-components'
import { segmentApi } from '@edulastic/api'
import {
  SearchSatisfactionResultsList,
  getGridCountInARow,
} from '../../../src/components/common/SearchSatisfaction'
import { BULK_CONVERTER_SEGMENT } from '../../../constants/bulkConverterSegment'
import { BASE_TITLE } from '../../../../config'
import {
  buildBulkConvertLandingSearchFilters,
  parsePdlBulkHandoffFromLocation,
  TEST_LIBRARY_TABS,
  markBulkConversionBannerDismissed,
  persistBulkConversionHandoff,
} from '../../utils/pdlBulkUploadHandoff'
import { isConversionBusy } from '../../utils/bulkConversionStatus'
import {
  ScrollBox,
  Container,
  ScrollbarWrapper,
  PaginationInfo,
  Filter,
  MobileFilter,
  Main,
  MainTopStatic,
  MainScrollBody,
  FilterButton,
  SearchModalContainer,
  CardContainer,
  PaginationWrapper,
  AffixWrapper,
  StyleChangeWrapper,
  CardBox,
  StyledCountText,
  ItemsMenu,
  LoaderOverlay,
  StatusFilterContainer,
  SelectAllLabel,
  ListToolbarRightCluster,
  BulkActionsCluster,
  BulkConvertStatusBarDisclaimer,
} from './styled'

import BulkConvertStatusBar from '../BulkConvertStatusBar'
import PdlBulkPostUploadToolbar from '../PdlBulkPostUploadToolbar'
import TestLibraryTabs from '../TestLibraryTabs'
import ReadyToReviewEmptyState from '../ReadyToReviewEmptyState'
import CardWrapper from '../CardWrapper/CardWrapper'
import {
  receiveTestsAction,
  getTestsSelector,
  getTestsLoadingSelector,
  getActiveTestListSearchFingerprintSelector,
  getTestListSearchFingerprint,
  getTestsCountSelector,
  getTestsLimitSelector,
  getTestsPageSelector,
  updateAllTestSearchFilterAction,
  getTestsFilterSelector,
  clearTestFiltersAction,
  filterMenuItems,
  emptyFilters,
  addTestToCartAction,
  removeTestFromCartAction,
  approveOrRejectMultipleTestsRequestAction,
  getSortFilterStateSelector,
  initialSortState,
  getSelectedTestsSelector,
  getIsAddingTestToCartStateSelector,
  moveTestsToDistrictRequestAction,
  clearReviewRequiredRequestAction,
  getShouldApplyDistrictLibraryFilterSelector,
  getMovingTestsToDistrictSelector,
  getClearingReviewRequiredSelector,
  clearApplyDistrictLibraryFilterAction,
} from '../../ducks'
import {
  getTestsCreatingSelector,
  getAllTagsAction,
} from '../../../TestPage/ducks'
import { setApproveConfirmationOpenAction } from '../../../TestPage/components/AddItems/ducks'
import { getCurriculumsListSelector } from '../../../src/selectors/dictionaries'
import {
  clearDictStandardsAction,
  getDictCurriculumsAction,
  getDictStandardsForCurriculumAction,
} from '../../../src/actions/dictionaries'

import ListHeader from '../../../src/components/common/ListHeader'
import TestListFilters from './TestListFilters'
import AddTestModal from '../../../PlaylistPage/components/AddTestsModal/AddTestModal'
import AddBulkTestModal from '../../../PlaylistPage/components/AddBulkTestModal/AddBulkTestModal'
import DeleteBulkTestModal from '../../../PlaylistPage/components/DeleteBulkTestModal/DeleteBulkTestModal'
import ManageModulesModalBody from '../../../CurriculumSequence/components/modals/ManageModulesModalBody'
import {
  StyledButton,
  BtnActionsContainer,
} from '../../../TestPage/components/AddItems/styled'
import {
  createNewModuleAction,
  updateModuleAction,
  deleteModuleAction,
  resequenceModulesAction,
  createTestInModuleAction,
  addTestToModuleInBulkAction,
  deleteTestFromModuleInBulkAction,
  removeTestFromPlaylistAction,
} from '../../../PlaylistPage/ducks'
import RemoveTestModal from '../../../PlaylistPage/components/RemoveTestModal/RemoveTestModal'
import {
  getInterestedCurriculumsSelector,
  getInterestedSubjectsSelector,
  getInterestedGradesSelector,
  getDefaultGradesSelector,
  getDefaultSubjectSelector,
  getUserFeatures,
  isContentConvertEnabledSelector,
  getUserOrgId,
  getCollectionsSelector,
  getUserRole,
  isOrganizationDistrictSelector,
  isDistrictUserSelector,
  isDistrictContentFilterEnabledSelector,
  isEnableBulkMoveContentToDistrictSelector,
  getUserSignupStatusSelector,
  getIsCurator,
} from '../../../src/selectors/user'
import {
  canShowDistrictBulkToolbar,
  canShowDistrictShareCheckboxForTest,
} from '../../utils/canShowDistrictShareCheckbox'
import {
  getInterestedStandardIdentifiersFromAlignmentData,
  setDefaultInterests,
  getNoDataTextForFilter,
  shouldUseRelevanceSortForEntireLibrary,
} from '../../../dataUtils'
import { trackSearchZeroResults } from '../../../constants/librarySearchSegment'
import {
  updateDefaultGradesAction,
  updateDefaultSubjectAction,
  isProxyUser as isProxyUserSelector,
  isDemoPlaygroundUser,
} from '../../../../student/Login/ducks'
import CartButton from '../CartButton/cartButton'
import FeaturesSwitch from '../../../../features/components/FeaturesSwitch'

import Actions from '../../../ItemList/components/Actions'
import SelectCollectionModal from '../../../ItemList/components/Actions/SelectCollection'
import HeaderFilter from '../../../ItemList/components/HeaderFilter'

import InputTag from '../../../ItemList/components/ItemFilter/SearchTag'
import SideContent from '../../../Dashboard/components/SideContent/Sidecontent'
import SortMenu from '../../../ItemList/components/SortMenu'
import ApproveConfirmModal from '../../../ItemList/components/ApproveConfirmModal'
import {
  getFilterFromSession,
  onEnterKeyPressHandler,
  setFilterInSession,
} from '../../../../common/utils/helpers'
import BuyAISuiteAlertModal from '../../../../common/components/BuyAISuiteAlertModal'
import EduAIQuiz from '../../../AssessmentCreate/components/CreateAITest'
import { CREATE_AI_TEST_DISPLAY_SCREENS } from '../../../AssessmentCreate/components/CreateAITest/constants'
import {
  NoDataContainer,
  StyledEduButton,
} from '../../../Reports/common/styled'
import NoDataNotification from '../../../../common/components/NoDataNotification'
import FilterToggleBtn from '../../../src/components/common/FilterToggleBtn'
import ItemCartButton from '../../../ItemList/components/CartButton/CartButton'
import { createTestFromCartAction } from '../../../ItemList/ducks'
import { FeatureBannerPlaceholder } from '../../../FeatureBanner'
import filterData from './FilterData'
import { getMatchingFilterObjects } from '../../../TestPage/components/AddItems/utils'
import { withAutoCompleteDict } from '../../../src/selectors/autoComplete'
import { StyledDisclaimerLink } from '../../../AIFeatures/common/styled'

// TODO: split into mulitple components, for performance sake.
// and only connect what is required.
// like seprating out filter and test rendering into two, and connect them to only what is required.

const LEGACY_BLOCKSTYLE_SESSION_KEY = 'testLibraryBlockstyle'
const MY_CONTENT_BLOCKSTYLE_SESSION_KEY = 'testLibraryBlockstyleMyContent'
const READY_TO_REVIEW_BLOCKSTYLE_SESSION_KEY =
  'testLibraryBlockstyleReadyReview'

const setBlockstyleInSession = (blockstyle, tabScope = 'legacy') => {
  const key =
    tabScope === 'myContent'
      ? MY_CONTENT_BLOCKSTYLE_SESSION_KEY
      : tabScope === 'readyReview'
      ? READY_TO_REVIEW_BLOCKSTYLE_SESSION_KEY
      : LEGACY_BLOCKSTYLE_SESSION_KEY
  sessionStorage.setItem(key, blockstyle)
}

const resolveLibraryBlockstyle = (tab, { isContentConvertEnabled } = {}) => {
  if (!isContentConvertEnabled) {
    return getFromSessionStorage(LEGACY_BLOCKSTYLE_SESSION_KEY) || 'tile'
  }
  if (tab === TEST_LIBRARY_TABS.READY_TO_REVIEW) {
    return (
      getFromSessionStorage(READY_TO_REVIEW_BLOCKSTYLE_SESSION_KEY) ||
      'horizontal'
    )
  }
  return getFromSessionStorage(MY_CONTENT_BLOCKSTYLE_SESSION_KEY) || 'tile'
}

class TestList extends Component {
  static propTypes = {
    tests: PropTypes.array.isRequired,
    receiveTests: PropTypes.func.isRequired,
    creating: PropTypes.bool.isRequired,
    page: PropTypes.number.isRequired,
    limit: PropTypes.number.isRequired,
    count: PropTypes.number.isRequired,
    loading: PropTypes.bool.isRequired,
    history: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    windowWidth: PropTypes.number.isRequired,
    curriculums: PropTypes.arrayOf(
      PropTypes.shape({
        _id: PropTypes.string.isRequired,
        curriculum: PropTypes.string.isRequired,
        grades: PropTypes.array.isRequired,
        subject: PropTypes.string.isRequired,
      })
    ).isRequired,
    getCurriculums: PropTypes.func.isRequired,
    getCurriculumStandards: PropTypes.func.isRequired,
    clearDictStandards: PropTypes.func.isRequired,
    userId: PropTypes.string.isRequired,
    playlist: PropTypes.object.isRequired,
    mode: PropTypes.string.isRequired,
    getAllTags: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props)
    this.lastTestSearchFilter = null

    const lastVisistedLibrary = getFilterFromSession({
      key: sessionFilterKeys.LAST_VISITED_LIBRARY,
      districtId: this.props.districtId,
      userId: this.props.userId,
    })

    if (
      lastVisistedLibrary !== LIBRARY_TYPES.TEST &&
      !_.isEmpty(lastVisistedLibrary)
    ) {
      ;[
        sessionFilters[`SEARCH_FILTER_${SMART_FILTERS.ENTIRE_LIBRARY}`],
        sessionFilters[`SEARCH_FILTER_${SMART_FILTERS.AUTHORED_BY_ME}`],
        sessionFilters[`SEARCH_FILTER_${SMART_FILTERS.SHARED_WITH_ME}`],
        sessionFilters[`SEARCH_FILTER_${SMART_FILTERS.CO_AUTHOR}`],
        sessionFilters[`SEARCH_FILTER_${SMART_FILTERS.PREVIOUSLY_USED}`],
        sessionFilters[`SEARCH_FILTER_${SMART_FILTERS.FAVORITES}`],
        sessionFilters[`SEARCH_FILTER_${SMART_FILTERS.FOLDERS}`],
      ].forEach((key) => {
        setFilterInSession({
          key,
          filter: {
            ...getFilterFromSession({
              key,
              districtId: this.props.districtId,
              userId: this.props.userId,
            }),
            curriculumId: '',
            standardIds: [],
          },
          userId: this.props.userId,
          districtId: this.props.districtId,
        })
      })
    }

    const lastFilter = getFilterFromSession({
      key: sessionFilterKeys.TEST_FILTER,
      districtId: this.props.districtId,
      userId: this.props.userId,
    })

    let lastFilterFolderId

    const lastFilterCategory = lastFilter.filter || SMART_FILTERS.ENTIRE_LIBRARY

    if (lastFilterCategory === SMART_FILTERS.FOLDERS && lastFilter.folderId) {
      lastFilterFolderId = lastFilter.folderId
    }

    const getMatchingObj = getMatchingFilterObjects({
      filterMenuItems,
      filter: lastFilterCategory,
    })?.[0]
    this.state = {
      standardQuery: '',
      blockstyle: 'tile',
      showCreateModuleModal: false,
      showManageModuleModal: false,
      showConfirmRemoveModal: false,
      showAddTestInModules: false,
      showAddModules: false,
      selectedTests: [],
      isShowFilter: false,
      markedTests: [],
      markedReviewTests: [],
      libraryTab: TEST_LIBRARY_TABS.MY_CONTENT,
      moduleModalAdd: null,
      openSidebar: false,
      isSingaporeMath: false,
      isBuyAISuiteAlertModalVisible: false,
      filter: {
        ...produce(emptyFilters, (draft) => {
          return draft
        }),
        ...(lastFilterCategory === SMART_FILTERS.FOLDERS
          ? {
              filter: SMART_FILTERS.FOLDERS,
              folderId: lastFilterFolderId,
            }
          : getFilterFromSession({
              key:
                sessionFilterKeys[
                  `SEARCH_FILTER_${
                    getMatchingObj?.sessionFilterKey || getMatchingObj?.filter
                  }`
                ],
              districtId: this.props.districtId,
              userId: this.props.userId,
            })),
      },
      prevFilter: {},
      showRightSideMenu: false,
      suggestions: [],
      suggestionKeyWord: '',
      /** Pear conversion + CSV affordance set when `BulkConvertStatusBar` completes (`clearBulkConvertLocationState`). */
      pdlBulkConversionDetail: null,
      pdlBulkCsvReadyForDownload: false,
      pdlBulkStatusBarDismissed: false,
      /** From PDL bulk handoff; kept in React state only (lost on refresh / leaving My Tests). */
      pdlBulkConversionId: null,
      pdlBulkFromConvert: false,
      /** Pear incomplete count from BulkConvertStatusBar poll (discovery without conversion id). */
      pdlBulkIncompleteCount: null,
    }

    setFilterInSession({
      key: sessionFilterKeys.LAST_VISITED_LIBRARY,
      districtId: this.props.districtId,
      userId: this.props.userId,
      filter: LIBRARY_TYPES.TEST,
    })
  }

  get isZoomedView() {
    const { windowWidth } = this.props
    return windowWidth <= parseInt(mobileWidthLarge.split('px')[0], 10)
  }

  isReadyToReviewTab = () => {
    const { isContentConvertEnabled } = this.props
    const { libraryTab, filter } = this.state
    return (
      isContentConvertEnabled &&
      libraryTab === TEST_LIBRARY_TABS.READY_TO_REVIEW &&
      filter?.filter === SMART_FILTERS.AUTHORED_BY_ME
    )
  }

  /** True while Ready tab shows the in-progress BulkConvertStatusBar (not complete/dismissed). */
  isBulkConversionInProgress = () => {
    const { isContentConvertEnabled, mode, playlist = {} } = this.props
    const {
      filter,
      pdlBulkConversionId,
      pdlBulkStatusBarDismissed,
      pdlBulkConversionDetail,
      pdlBulkCsvReadyForDownload,
      pdlBulkIncompleteCount,
    } = this.state

    if (
      !isContentConvertEnabled ||
      playlist._id ||
      mode === 'embedded' ||
      filter?.filter !== SMART_FILTERS.AUTHORED_BY_ME ||
      !this.isReadyToReviewTab() ||
      pdlBulkStatusBarDismissed ||
      pdlBulkCsvReadyForDownload
    ) {
      return false
    }

    if (pdlBulkIncompleteCount > 0) {
      return true
    }

    if (!pdlBulkConversionId) {
      return false
    }

    return (
      !pdlBulkConversionDetail?.status ||
      isConversionBusy(pdlBulkConversionDetail)
    )
  }

  buildTestSearch = (baseFilter = {}, tabOverride) => {
    const { isContentConvertEnabled } = this.props
    const tab = tabOverride ?? this.state.libraryTab
    const search = { ...baseFilter }
    delete search.tab
    const readyTab =
      isContentConvertEnabled && tab === TEST_LIBRARY_TABS.READY_TO_REVIEW
    if (readyTab && search.filter === SMART_FILTERS.AUTHORED_BY_ME) {
      search.isReviewRequired = true
    } else {
      delete search.isReviewRequired
    }
    return search
  }

  fetchTests = (params, tabOverride) => {
    const { receiveTests } = this.props
    const search = params.search
      ? this.buildTestSearch(params.search, tabOverride)
      : params.search
    if (search) {
      this.lastTestSearchFilter = search
    }
    receiveTests({ ...params, search })
  }

  /** Same-page Convert Document: mount does not re-run — apply grade/subject from URL. */
  applyPdlBulkUploadFilters = (location) => {
    const searchParams = qs.parse(location.search || '', {
      ignoreQueryPrefix: true,
    })
    const { sort, limit, isContentConvertEnabled } = this.props
    const searchFilters = buildBulkConvertLandingSearchFilters(searchParams, {
      isSingaporeMath: this.state.isSingaporeMath,
    })
    const tabOverride =
      isContentConvertEnabled &&
      searchParams.tab === TEST_LIBRARY_TABS.READY_TO_REVIEW
        ? TEST_LIBRARY_TABS.READY_TO_REVIEW
        : undefined
    this.updateFilterState(searchFilters, sort, true)
    this.fetchTests(
      { page: 1, limit, search: searchFilters, sort },
      tabOverride
    )
    return true
  }

  buildTestLibraryQueryParams = (searchFilters, page, limit) =>
    qs.stringify(
      pickBy(
        {
          ...searchFilters,
          page,
          limit,
          ...(this.props.isContentConvertEnabled
            ? { tab: this.state.libraryTab }
            : {}),
        },
        identity
      )
    )

  handleLibraryTabChange = (tab) => {
    const { history, limit, isContentConvertEnabled } = this.props
    const { filter } = this.state
    if (!isContentConvertEnabled) return
    const queryParams = qs.stringify(
      pickBy({ ...filter, page: 1, limit, tab }, identity)
    )
    history.push(`/author/tests?${queryParams}`)
    this.syncLibraryTabState(tab)
  }

  /** Tab click + browser back/forward: sync UI state and refetch for the active tab search. */
  syncLibraryTabState = (tab) => {
    const { limit, sort, isContentConvertEnabled } = this.props
    const { filter, libraryTab: prevTab } = this.state
    let blockstyleForTab = resolveLibraryBlockstyle(tab, {
      isContentConvertEnabled,
    })
    if (
      tab === TEST_LIBRARY_TABS.MY_CONTENT &&
      prevTab === TEST_LIBRARY_TABS.READY_TO_REVIEW
    ) {
      blockstyleForTab = 'tile'
      setBlockstyleInSession('tile', 'myContent')
    }
    this.setState(
      (prev) => ({
        libraryTab: tab,
        blockstyle: blockstyleForTab,
        markedReviewTests:
          tab === TEST_LIBRARY_TABS.READY_TO_REVIEW
            ? prev.markedReviewTests
            : [],
        markedTests:
          tab === TEST_LIBRARY_TABS.MY_CONTENT ? prev.markedTests : [],
      }),
      () => {
        this.fetchTests({ page: 1, limit, search: filter, sort })
      }
    )
  }

  static getDerivedStateFromProps(props, prevState) {
    const { features, mode, isContentConvertEnabled } = props
    if (isContentConvertEnabled && mode !== 'embedded') {
      return {
        ...prevState,
        blockstyle: resolveLibraryBlockstyle(prevState.libraryTab, {
          isContentConvertEnabled,
        }),
      }
    }
    const localBlockstyle = getFromSessionStorage(LEGACY_BLOCKSTYLE_SESSION_KEY)
    if (localBlockstyle) {
      return {
        ...prevState,
        blockstyle: localBlockstyle,
      }
    }
    if (features.isCurator && mode !== 'embedded') {
      setBlockstyleInSession('horizontal')
      return {
        ...prevState,
        blockstyle: 'horizontal',
      }
    }
    setBlockstyleInSession('tile')
    return prevState
  }

  componentDidMount() {
    const {
      curriculums,
      getCurriculums,
      page,
      limit,
      location,
      history,
      playlist = {},
      mode,
      match: params,
      getCurriculumStandards,
      getAllTags,
      clearDictStandards,
      sort: initSort = {},
      tests,
      user,
      districtId,
      userId,
      collections,
      isContentConvertEnabled,
    } = this.props
    const { filter } = this.state
    const pdlBulkHandoff = parsePdlBulkHandoffFromLocation(location)

    const isSingaporeMathCollectionActive = tests.filter(
      (test) =>
        (test.description?.toLowerCase()?.includes('singaporemath') ||
          test.description?.toLowerCase()?.includes('singapore math')) &&
        test?.active
    )

    const isSingaporeMath =
      user?.referrer?.includes('singapore') ||
      user?.utm_source?.toLowerCase()?.includes('singapore') ||
      isSingaporeMathCollectionActive?.length > 0 ||
      collections.some((itemBank) =>
        itemBank?.owner?.toLowerCase().includes('singapore')
      )

    this.setState({
      isSingaporeMath,
      ...(pdlBulkHandoff.bulkConversionId || pdlBulkHandoff.fromBulkConvert
        ? {
            pdlBulkConversionId: pdlBulkHandoff.bulkConversionId,
            pdlBulkFromConvert: pdlBulkHandoff.fromBulkConvert,
            pdlBulkStatusBarDismissed: false,
          }
        : {}),
    })

    if (
      (pdlBulkHandoff.bulkConversionId || pdlBulkHandoff.fromBulkConvert) &&
      history?.replace
    ) {
      if (location.state?.fromBulkConvert && pdlBulkHandoff.bulkConversionId) {
        persistBulkConversionHandoff(pdlBulkHandoff.bulkConversionId)
      }
      history.replace({
        pathname: location.pathname,
        search: location.search || '',
        state: {},
      })
    }

    const sessionSort = getFilterFromSession({
      key: sessionFilterKeys.TEST_SORT,
      districtId,
      userId,
    })

    // propagate filter from query params to the store (test.filters)
    let searchParams = qs.parse(location.search, { ignoreQueryPrefix: true })

    let searchFilters = {}

    if (location.state?.fromBulkConvert) {
      searchFilters = buildBulkConvertLandingSearchFilters(searchParams, {
        isSingaporeMath,
      })
    } else {
      searchFilters = {
        ...filter,
      }

      searchFilters.isSingaporeMath = isSingaporeMath
    }

    const sort = {
      ...initSort,
      sortBy:
        searchFilters.filter === SMART_FILTERS.ENTIRE_LIBRARY &&
        shouldUseRelevanceSortForEntireLibrary(this.props)
          ? 'relevance'
          : 'popularity',
      sortDir: 'desc',
      ...sessionSort,
    }

    searchParams = this.typeCheck(searchParams, searchFilters)
    const effectiveFilter = searchParams.filter || searchFilters.filter
    const tabFromQuery =
      isContentConvertEnabled &&
      effectiveFilter === SMART_FILTERS.AUTHORED_BY_ME &&
      (searchParams.tab === TEST_LIBRARY_TABS.READY_TO_REVIEW ||
        pdlBulkHandoff.fromBulkConvert ||
        pdlBulkHandoff.bulkConversionId)
        ? TEST_LIBRARY_TABS.READY_TO_REVIEW
        : TEST_LIBRARY_TABS.MY_CONTENT
    if (Object.keys(searchParams).length) {
      searchParams.curriculumId =
        Number(searchParams.curriculumId) || searchFilters.curriculumId || ''
      searchParams.standardIds = searchParams.standardIds
        ? searchParams.standardIds.map((item) => ({
            ...item,
            _id: parseInt(item._id, 10),
          }))
        : []
      const { searchString = [] } = searchParams
      if (searchString?.length > 5) {
        searchParams.searchString = searchString.slice(0, 5)
      }
      Object.assign(searchFilters, pick(searchParams, Object.keys(filter)))
      if (searchParams.grades?.length) {
        searchFilters.grades = Array.isArray(searchParams.grades)
          ? searchParams.grades
          : [searchParams.grades]
      }
      if (searchParams.subject?.length) {
        searchFilters.subject = Array.isArray(searchParams.subject)
          ? searchParams.subject
          : [searchParams.subject]
      }
    }

    const blockstyleForTab = resolveLibraryBlockstyle(tabFromQuery, {
      isContentConvertEnabled,
    })

    this.setState(
      {
        libraryTab: tabFromQuery,
        blockstyle: blockstyleForTab,
      },
      () => {
        this.updateFilterState(searchFilters, sort, true)

        if (mode === 'embedded') {
          const selectedTests = []
          const { modules } = playlist
          const { state = {} } = location
          const { editFlow } = state
          modules?.forEach((mod) => {
            mod.data.forEach((test) => {
              selectedTests.push(test.contentId)
            })
          })
          this.setState({
            selectedTests,
            editFlow,
            blockstyle: 'horizontal',
          })
          setBlockstyleInSession('horizontal')
          this.fetchTests(
            {
              page: 1,
              limit,
              search: searchFilters,
              sort,
            },
            tabFromQuery
          )
        } else {
          if (!curriculums.length) {
            getCurriculums()
          }
          const searchParamsPageNumber = parseInt(searchParams.page, 10)
          const pageNumber = params.page || searchParamsPageNumber || page
          const limitCount = params.limit || limit
          const queryParams = qs.stringify(
            pickBy(
              {
                ...searchFilters,
                page: pageNumber,
                limit: limitCount,
                ...(isContentConvertEnabled ? { tab: tabFromQuery } : {}),
              },
              identity
            )
          )
          history.push(`/author/tests?${queryParams}`)
          this.fetchTests(
            { page: pageNumber, limit, search: searchFilters, sort },
            tabFromQuery
          )
          getAllTags({ type: 'test' })
        }

        if (searchFilters.curriculumId) {
          const {
            curriculumId: _curriculumId,
            grades: curriculumGrades = [],
          } = searchFilters
          clearDictStandards()
          getCurriculumStandards(_curriculumId, curriculumGrades, '')
        }
      }
    )
  }

  computeSuggestions(e) {
    const target = e.target

    const values = (target.value || '').split(' ')
    const value = values[values.length - 1].toLowerCase()
    let allPossibleValues = []
    if (target.value.length >= 3 && value.length) {
      allPossibleValues = this.props.autoCompleteDict.filter(
        (str) => str.startsWith(value) && str != value
      )
    }
    allPossibleValues.splice(5)
    this.setState({
      suggestions: allPossibleValues.map(
        (word) => target.value + word.slice(value?.length || 0)
      ),
      suggestionKeyWord: target.value,
    })
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      page,
      count,
      limit,
      loading,
      activeTestListSearchFingerprint,
      enableDistrictContentFilter,
      shouldApplyDistrictLibraryFilter,
      clearApplyDistrictLibraryFilter,
      playlist = {},
      mode,
      location,
      history,
      userId,
    } = this.props

    if (prevProps.userId && userId && prevProps.userId !== userId) {
      this.setState({
        pdlBulkConversionId: null,
        pdlBulkFromConvert: false,
        pdlBulkStatusBarDismissed: false,
        pdlBulkConversionDetail: null,
        pdlBulkCsvReadyForDownload: false,
        pdlBulkIncompleteCount: null,
      })
    }

    const state = location.state || {}
    const prevSt = prevProps.location?.state || {}
    if (
      state.fromBulkConvert &&
      (state.fromBulkConvert !== prevSt.fromBulkConvert ||
        state.bulkConversionId !== prevSt.bulkConversionId)
    ) {
      const bulkConversionId = state.bulkConversionId ?? null
      if (bulkConversionId) {
        persistBulkConversionHandoff(bulkConversionId)
      }
      this.applyPdlBulkUploadFilters(location)
      this.setState({
        pdlBulkConversionId: bulkConversionId,
        pdlBulkFromConvert: true,
        pdlBulkStatusBarDismissed: false,
      })
      if (history?.replace) {
        history.replace({
          pathname: location.pathname,
          search: location.search || '',
          state: {},
        })
      }
    }
    if (
      prevState?.filter?.filter === SMART_FILTERS.AUTHORED_BY_ME &&
      this.state.filter?.filter !== SMART_FILTERS.AUTHORED_BY_ME &&
      (this.state.markedTests || []).length > 0
    ) {
      this.setState({ markedTests: [] })
    }
    if (
      prevState?.libraryTab === TEST_LIBRARY_TABS.READY_TO_REVIEW &&
      this.state.libraryTab !== TEST_LIBRARY_TABS.READY_TO_REVIEW &&
      (this.state.markedReviewTests || []).length > 0
    ) {
      this.setState({ markedReviewTests: [] })
    }
    const { isContentConvertEnabled } = this.props
    if (
      isContentConvertEnabled &&
      location.search !== prevProps.location.search
    ) {
      const searchParams = qs.parse(location.search || '', {
        ignoreQueryPrefix: true,
      })
      if (searchParams.tab) {
        const tabFromUrl =
          this.state.filter?.filter === SMART_FILTERS.AUTHORED_BY_ME &&
          searchParams.tab === TEST_LIBRARY_TABS.READY_TO_REVIEW
            ? TEST_LIBRARY_TABS.READY_TO_REVIEW
            : TEST_LIBRARY_TABS.MY_CONTENT
        if (tabFromUrl !== this.state.libraryTab) {
          this.syncLibraryTabState(tabFromUrl)
        }
      }
    }
    if (
      shouldApplyDistrictLibraryFilter &&
      !prevProps.shouldApplyDistrictLibraryFilter
    ) {
      this.setState({ markedTests: [] })
      clearApplyDistrictLibraryFilter()
      if (!playlist._id && mode !== 'embedded') {
        const { sort, history: hist } = this.props
        const { filter } = this.state
        /** Same value as collection filter option in TestListFilters (sharing scope). */
        const COLLECTION_FILTER_DISTRICT = 'DISTRICT'
        const prevCols = filter.collections || []
        const nextCollections = prevCols.includes(COLLECTION_FILTER_DISTRICT)
          ? prevCols
          : [COLLECTION_FILTER_DISTRICT, ...prevCols]
        const mergedFilter = { ...filter, collections: nextCollections }
        this.updateFilterState(mergedFilter, sort, true)
        const queryParams = qs.stringify(
          pickBy({ ...mergedFilter, page: 1, limit }, identity)
        )
        hist.push(`/author/tests?${queryParams}`)
        this.fetchTests({ page: 1, limit, search: mergedFilter, sort })
      }
    }
    const { filter, prevFilter } = this.state
    if (
      count &&
      page > 1 &&
      page > Math.floor(count / limit) + 1 &&
      page !== prevProps.page
    ) {
      this.handlePaginationChange(Math.floor(count / limit) + 1)
    }
    if (!_.isEqual(filter, prevFilter) || prevProps.page !== page) {
      segmentApi.genericEventTrack('test search', {
        enableDistrictContentFilter,
        filter,
        libraryType: 'test',
        sessionId: window.sessionStorage.kid,
        page,
      })
      this.setState({ prevFilter: filter })
    }

    const searchFingerprint = getTestListSearchFingerprint(
      this.buildTestSearch(filter)
    )
    if (
      activeTestListSearchFingerprint !==
        prevProps.activeTestListSearchFingerprint &&
      prevProps.activeTestListSearchFingerprint != null &&
      activeTestListSearchFingerprint === searchFingerprint &&
      !loading &&
      count === 0
    ) {
      trackSearchZeroResults({
        filter: this.buildTestSearch(this.lastTestSearchFilter || filter),
        libraryType: 'test',
        userId,
      })
    }

    if (
      !this.state.pdlBulkConversionId &&
      (this.state.pdlBulkConversionDetail != null ||
        this.state.pdlBulkCsvReadyForDownload ||
        this.state.pdlBulkStatusBarDismissed)
    ) {
      this.setState({
        pdlBulkConversionDetail: null,
        pdlBulkCsvReadyForDownload: false,
        pdlBulkStatusBarDismissed: false,
      })
    }
  }

  updateFilterState = (searchState, sortState, all) => {
    const { updateAllTestFilters, districtId, userId } = this.props
    const { filter } = this.state
    const search = all
      ? // eslint-disable-next-line react/destructuring-assignment, react/no-access-state-in-setstate
        { ...searchState, isSingaporeMath: this.state.isSingaporeMath }
      : {
          ...filter,
          [searchState.key]: searchState.value,
          // eslint-disable-next-line react/destructuring-assignment, react/no-access-state-in-setstate
          isSingaporeMath: this.state.isSingaporeMath,
        }
    const getMatchingObj = getMatchingFilterObjects({
      filterMenuItems,
      filter: search.filter,
    })?.[0]
    setFilterInSession({
      key:
        sessionFilterKeys[
          `SEARCH_FILTER_${
            getMatchingObj?.sessionFilterKey || getMatchingObj?.filter
          }`
        ],
      filter: search,
      districtId,
      userId,
    })
    setFilterInSession({
      key: sessionFilterKeys.TEST_FILTER,
      filter: { filter: search.filter, folderId: search.folderId },
      districtId,
      userId,
    })
    setFilterInSession({
      key: sessionFilterKeys.TEST_SORT,
      filter: sortState,
      districtId,
      userId,
    })
    this.setState({
      filter: search,
    })
    if (all) {
      return updateAllTestFilters({ sort: sortState })
    }
  }

  searchTest = debounce((search) => {
    const {
      limit,
      history,
      playlistPage,
      playlist: { _id } = {},
      sort,
    } = this.props
    const queryParams = this.buildTestLibraryQueryParams(search, 1, limit)
    const locToPush = playlistPage
      ? `/author/playlists/${_id}/edit`
      : `/author/tests?${queryParams}`
    history.push(locToPush)
    this.fetchTests({ search, limit, page: 1, sort })
  }, 500)

  handleSearchInputChange = (tags) => {
    const { sort } = this.props
    const { filter } = this.state
    const newSearch = {
      ...filter,
      searchString: uniq(tags.map((t) => (t.length > 64 ? t.slice(0, 65) : t))),
    }
    this.updateFilterState(newSearch, sort, true)
    this.searchTest(newSearch)
  }

  /**
   * invoked when any of the filter changes.
   * @params name {String} - name of the filt.er
   * @params value {Sring} - filter value
   */
  handleFiltersChange = (name, value, dateString) => {
    const {
      clearDictStandards,
      history,
      limit,
      getCurriculumStandards,
      updateDefaultGrades,
      updateDefaultSubject,
      playlistPage,
      playlist: { _id } = {},
      sort = {},
    } = this.props
    const { filter } = this.state

    if (name === 'folderId') {
      const searchfilterWithFolder = {
        ...emptyFilters,
        [name]: value,
        filter: 'FOLDERS',
      }
      this.updateFilterState(searchfilterWithFolder, sort, true)
      return this.fetchTests({
        search: searchfilterWithFolder,
        sort,
        page: 1,
        limit,
      })
    }
    // all the fields to pass for search.

    let updatedKeys = {
      ...filter,
    }

    if (name === 'grades' || name === 'subject' || name === 'curriculumId') {
      setDefaultInterests({ [name]: value })
    }

    if (name === 'curriculumId') {
      clearDictStandards()
      getCurriculumStandards(value, filter.grades, '')
      updatedKeys = {
        ...updatedKeys,
        standardIds: [],
      }
    }
    if (name === 'grades' && filter.curriculumId) {
      clearDictStandards()
      getCurriculumStandards(filter.curriculumId, value, '')
    }
    if (name === 'subject') {
      updatedKeys = {
        ...updatedKeys,
        [name]: value,
        curriculumId: '',
        standardIds: [],
      }
      updateDefaultSubject(value)
      storeInLocalStorage('defaultSubject', value)
      clearDictStandards()
    }
    if (name === 'createdAt') {
      updatedKeys = {
        ...updatedKeys,
        [name]: value ? moment(dateString, 'DD/MM/YYYY').valueOf() : '',
      }
    } else {
      updatedKeys = {
        ...updatedKeys,
        [name]: value,
      }
    }
    if (name === 'grades') {
      updateDefaultGrades(value)
      storeInLocalStorage('defaultGrades', value)
    }
    const searchFilters = {
      ...updatedKeys,
      [name]: name === 'createdAt' ? updatedKeys[name] : value,
    }
    this.updateFilterState(searchFilters, sort, true)
    // update the url to reflect the newly applied filter and get the new results.
    const queryParams = this.buildTestLibraryQueryParams(
      searchFilters,
      1,
      limit
    )
    const locToPush = playlistPage
      ? `/author/playlists/${_id}/edit`
      : `/author/tests?${queryParams}`
    history.push(locToPush)
    this.fetchTests({ search: searchFilters, sort, page: 1, limit })
  }

  handleCreate = () => {
    const { history, mode } = this.props
    if (mode !== 'embedded') {
      history.push('/author/tests/select')
    }
  }

  updateTestList = (page) => {
    const {
      limit,
      history,
      playlistPage,
      playlist: { _id } = {},
      sort,
    } = this.props
    const { filter } = this.state
    const searchFilters = {
      ...filter,
    }

    const queryParams = this.buildTestLibraryQueryParams(
      searchFilters,
      page,
      limit
    )
    const locToPush = playlistPage
      ? `/author/playlists/${_id}/edit`
      : `/author/tests?${queryParams}`
    history.push(locToPush)
    this.fetchTests({ page, limit, search: searchFilters, sort })
  }

  handlePaginationChange = (page) => {
    this.updateTestList(page)
  }

  handleClearFilter = () => {
    const { mode, limit, sort, history } = this.props
    const { filter } = this.state
    const clearedSort = {
      ...initialSortState,
      sortBy:
        filter.filter === SMART_FILTERS.ENTIRE_LIBRARY &&
        shouldUseRelevanceSortForEntireLibrary(this.props)
          ? 'relevance'
          : initialSortState.sortBy,
    }

    const clearedFilters = produce(emptyFilters, (draft) => {
      draft.isSingaporeMath = this.state.isSingaporeMath
      draft.filter = filter.filter
    })

    // If current filter and initial filter is equal don't need to reset again
    if (isEqual(filter, clearedFilters) && isEqual(sort, clearedSort))
      return null

    this.updateFilterState(clearedFilters, clearedSort, true)
    setDefaultInterests({ subject: [], grades: [], curriculumId: '' })
    if (mode !== 'embedded') {
      const reviewTab = this.isReadyToReviewTab()
        ? `&tab=${TEST_LIBRARY_TABS.READY_TO_REVIEW}`
        : ''
      history.push(
        `/author/tests?filter=ENTIRE_LIBRARY&limit=${limit}&page=1${reviewTab}`
      )
    }
    this.fetchTests({
      page: 1,
      limit,
      search: clearedFilters,
      sort: clearedSort,
    })
  }

  handleStyleChange = (blockstyle) => {
    const { isContentConvertEnabled } = this.props
    const { libraryTab } = this.state
    this.setState({
      blockstyle,
    })
    if (!isContentConvertEnabled) {
      setBlockstyleInSession(blockstyle, 'legacy')
      return
    }
    setBlockstyleInSession(
      blockstyle,
      libraryTab === TEST_LIBRARY_TABS.READY_TO_REVIEW
        ? 'readyReview'
        : 'myContent'
    )
  }

  showFilterHandler = () => {
    this.setState({ isShowFilter: true })
  }

  closeSearchModal = () => {
    this.setState({ isShowFilter: false })
  }

  setAISuiteAlertModalVisibility = (value) => {
    this.setState({ isBuyAISuiteAlertModalVisible: value })
  }

  typeCheck = (parsedQueryData, search) => {
    const parsedQueryDataClone = {}
    for (const key of Object.keys(parsedQueryData)) {
      if (
        search[key] instanceof Array &&
        !(parsedQueryData[key] instanceof Array)
      ) {
        parsedQueryDataClone[key] = [parsedQueryData[key]]
      } else {
        parsedQueryDataClone[key] = parsedQueryData[key]
      }
    }
    return parsedQueryDataClone
  }

  setFilterParams(parsedQueryData) {
    const {
      getCurriculumStandards,
      match: { params = {} },
      sort,
    } = this.props
    const { filter } = this.state

    const search = {
      ...filter,
    }

    parsedQueryData = this.typeCheck(parsedQueryData, search)
    const searchClone = {
      ...filter,
    }

    for (const key of Object.keys(parsedQueryData)) {
      if (has(filter, key)) {
        searchClone[key] = parsedQueryData[key]
      }
    }

    this.updateFilterState(searchClone, sort, true)

    const { curriculumId, grade } = searchClone
    if (curriculumId && parsedQueryData.standardQuery.length >= 2) {
      getCurriculumStandards(curriculumId, grade, parsedQueryData.standardQuery)
    }
    this.fetchTests({
      page: Number(params.page),
      limit: Number(params.limit),
      search: searchClone,
      sort,
    })
  }

  handleCreateNewModule = () => {
    this.setState({ showCreateModuleModal: true })
  }

  handleManageModule = () => {
    this.setState({ showManageModuleModal: true })
  }

  onCloseManageModule = () => {
    this.setState({ showManageModuleModal: false })
  }

  handleSaveModule = () => {
    const { handleSave } = this.props
    handleSave()
    this.setState({ showManageModuleModal: false })
  }

  deleteModule = (id) => {
    const { selectedTests } = this.state
    const { playlist, deleteModuleFromPlaylist } = this.props
    const moduleData = playlist?.modules?.[id]?.data?.map((x) => x.contentId)
    const newSelectedTests = selectedTests?.filter(
      (testId) => !moduleData.includes(testId)
    )
    this.setState({ selectedTests: newSelectedTests }, () =>
      deleteModuleFromPlaylist(id)
    )
  }

  handleAddTests = (item) => {
    if (!item) {
      console.error('Test data is missing while adding tests in bulk..')
      return
    }

    if (item?.status === 'draft' || item?.status === 'rejected') {
      const testStatus = item?.status === 'draft' ? 'Draft' : 'Rejected'
      notification({
        type: 'warn',
        msg: `${testStatus} tests cannot be added`,
      })
      return
    }

    const {
      playlist: { modules },
    } = this.props
    if (!modules.length) {
      this.setState({
        showManageModuleModal: true,
        moduleModalAdd: true,
        testAdded: item,
      })
      notification({ type: 'warn', messageKey: 'createOneModuleAtleast' })
    } else {
      this.setState({ showAddTestInModules: true, testAdded: item })
    }
  }

  handleBulkAddTests = () => {
    const { markedTests } = this.state
    const { playlist: { modules } = {} } = this.props
    if (modules?.length) {
      if (markedTests.length) {
        this.setState({ showAddModules: true })
      } else {
        notification({ type: 'warn', messageKey: 'selectOneOrMoreTest' })
      }
    } else {
      notification({ type: 'warn', messageKey: 'createOneModuleAtleast' })
    }
  }

  handleBulkRemoveTests = () => {
    const { markedTests } = this.state
    const { playlist: { modules } = {} } = this.props
    if (modules?.length) {
      if (markedTests.length) {
        this.setState({ showRemoveModules: true })
      } else {
        notification({ type: 'warn', messageKey: 'selectOneOrMoreTest' })
      }
    } else {
      notification({ type: 'warn', messageKey: 'createOneModuleAtleast' })
    }
  }

  getDistrictShareCheckboxContext = () => {
    const {
      userId,
      userRole,
      features,
      userSignupStatus,
      maxSharingLevelAllowed,
      isCurator,
      isDemoAccount,
      isContentConvertEnabled,
      enableBulkMoveContentToDistrict,
    } = this.props
    return {
      userId,
      userRole,
      features,
      userSignupStatus,
      maxSharingLevelAllowed,
      isCurator,
      isDemoPlaygroundUser: isDemoAccount,
      isContentConvertEnabled,
      enableBulkMoveContentToDistrict,
    }
  }

  handleCheckboxAction = (e, prop) => {
    const { markedTests } = this.state
    if (e.target.checked) {
      this.setState({ markedTests: [...markedTests, prop] })
    } else {
      this.setState({
        markedTests: markedTests.filter((data) => data._id !== prop._id),
      })
    }
  }

  handleReviewCheckboxAction = (e, prop) => {
    const { markedReviewTests } = this.state
    if (e.target.checked) {
      this.setState({ markedReviewTests: [...markedReviewTests, prop] })
    } else {
      this.setState({
        markedReviewTests: markedReviewTests.filter(
          (data) => data._id !== prop._id
        ),
      })
    }
  }

  handleMoveContent = () => {
    const { markedReviewTests, filter } = this.state
    const { page, limit, sort, clearReviewRequiredRequest } = this.props
    if (!markedReviewTests?.length) {
      notification({
        type: 'warn',
        msg: 'Select at least one test to move content.',
      })
      return
    }
    const testIds = markedReviewTests.map((m) => (m._id != null ? m._id : m))
    AntdModal.confirm({
      title: 'Move Content?',
      okText: 'Move Content',
      cancelText: 'Cancel',
      width: 500,
      content: (
        <div>
          <p>
            Move{' '}
            <strong>
              {testIds.length} test{testIds.length === 1 ? '' : 's'}
            </strong>{' '}
            to Created by Me? Tests will remain as drafts and will no longer
            appear in Pending Review tab.
          </p>
        </div>
      ),
      onOk: () => {
        clearReviewRequiredRequest({
          testIds,
          search: this.buildTestSearch(filter),
          sort,
          page,
          limit,
        })
        this.setState({ markedReviewTests: [] })
      },
    })
  }

  onCloseCreateModule = () => {
    this.setState({ showCreateModuleModal: false })
  }

  onCloseAddTestModal = () => {
    this.setState({ showAddTestInModules: false })
  }

  onCloseBulkAddTestModal = () => {
    this.setState({ showAddModules: false })
  }

  onCloseBulkDeleteTestModal = () => {
    this.setState({ showRemoveModules: false })
  }

  removeTestFromPlaylist = () => {
    const { selectedTests, removeItemId } = this.state
    const { deleteTestFromPlaylist } = this.props
    const newSelectedTests = selectedTests.filter(
      (testId) => testId !== removeItemId
    )
    deleteTestFromPlaylist({ itemId: removeItemId })
    this.setState({
      selectedTests: newSelectedTests,
      showConfirmRemoveModal: false,
    })
  }

  handleRemoveTest = (itemId) => {
    const { removeTestFromPlaylist } = this
    this.setState({ removeItemId: itemId }, () => {
      removeTestFromPlaylist()
    })
  }

  onCloseConfirmRemoveModal = () => {
    this.setState({ showConfirmRemoveModal: false })
  }

  handleTestAdded = (index) => {
    const { addTestToModule, handleSave } = this.props
    const { testAdded, selectedTests } = this.state
    this.setState((prevState) => ({
      ...prevState,
      selectedTests: [...selectedTests, testAdded._id],
      moduleModalAdd: null,
    }))
    addTestToModule({ moduleIndex: index, testAdded })
    if (selectedTests.length === 0) handleSave()
  }

  handleBulkTestAdded = (index) => {
    const {
      addTestToModuleInBulk,
      handleSave,
      playlist: { modules = [] } = {},
      tests = [],
    } = this.props
    const { markedTests, selectedTests } = this.state
    const addedTestIds = modules.flatMap((x) => x.data.map((y) => y.contentId))
    const markedIds = markedTests.map((obj) => obj._id)
    const uniqueMarkedIds = markedIds.filter((x) => !addedTestIds.includes(x))
    const uniqueMarkedTests = markedTests.filter((x) =>
      uniqueMarkedIds.includes(x._id)
    )
    if (uniqueMarkedIds.length !== markedIds.length) {
      if (uniqueMarkedIds.length === 0) {
        notification({
          type: 'warn',
          messageKey: 'selectedTestAlreadyExistInModule',
        })
        return
      }
      if (
        uniqueMarkedIds.length < markedIds.length &&
        uniqueMarkedIds.length !== 0
      )
        notification({
          type: 'warn',
          messageKey: 'someSelectedTestAlreadyExistInModule',
        })
    }

    // Dont add draft type tests
    const nonDraftTests = uniqueMarkedTests.filter(
      (x) => tests.find((y) => y._id === x._id).status !== 'draft'
    )
    if (nonDraftTests.length === uniqueMarkedTests.length) {
      this.setState(() => ({
        selectedTests: [...selectedTests, ...uniqueMarkedIds],
        markedTests: [],
      }))
      const uniqueMarkedTestsIds = uniqueMarkedTests.map((x) => x?._id)
      const testsToAdd = tests.filter((x) =>
        uniqueMarkedTestsIds?.includes(x?._id)
      )
      const testsWithStandardIdentifiers = testsToAdd?.map((x) => ({
        ...x,
        standardIdentifiers: x?.summary?.standards?.reduce(
          (a, c) => a.concat(c?.identifier),
          []
        ),
      }))
      addTestToModuleInBulk({
        moduleIndex: index,
        tests: testsWithStandardIdentifiers,
      })
      notification({ type: 'success', messageKey: 'testAddedPlalist' })
    } else {
      const nonDraftIds = nonDraftTests.map((x) => x._id)
      this.setState(() => ({
        selectedTests: [...selectedTests, ...nonDraftIds],
        markedTests: [],
      }))
      const nonDraftTestsIds = nonDraftTests?.map((x) => x?._id)
      const testsToAdd = tests.filter((x) => nonDraftTestsIds?.includes(x?._id))
      const testsWithStandardIdentifiers = testsToAdd?.map((x) => ({
        ...x,
        standardIdentifiers: x?.summary?.standards?.reduce(
          (a, c) => a.concat(c?.identifier),
          []
        ),
      }))
      addTestToModuleInBulk({
        moduleIndex: index,
        tests: testsWithStandardIdentifiers,
      })
      nonDraftTests.length
        ? notification({
            type: 'warn',
            msg: `${nonDraftTests.length}/${markedTests.length} are added to ${modules[index].title}`,
          })
        : notification({ type: 'warn', messageKey: 'draftTestCantBeAdded' })
    }
    if (selectedTests.length === 0) handleSave()
  }

  handleBulkTestDelete = (len) => {
    const { deleteTestFromModuleInBulk } = this.props
    const { markedTests, selectedTests } = this.state
    const testIds = markedTests.map((test) => test._id)
    this.setState((prevState) => ({
      ...prevState,
      selectedTests: [...selectedTests.filter((x) => !testIds.includes(x))],
      markedTests: [],
    }))
    if (len) {
      deleteTestFromModuleInBulk({ testIds })
      notification({ type: 'success', messageKey: 'testremovedPlaylist' })
    } else {
      notification({ type: 'success', messageKey: 'selectedTestAreCleared' })
    }
  }

  searchFilterOption = (input, option) =>
    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0

  onAddToCart = (item) => {
    const { addTestToCart } = this.props
    addTestToCart(item)
  }

  onRemoveFromCart = (item) => {
    const { removeTestFromCart } = this.props
    removeTestFromCart(item)
  }

  toggleSidebar = () =>
    this.setState((prevState) => ({ openSidebar: !prevState.openSidebar }))

  renderCardContent = () => {
    const {
      tests,
      windowWidth,
      history,
      match,
      userId,
      mode,
      interestedCurriculums,
      playlist = {},
      movingTestsToDistrict,
    } = this.props
    const { filter } = this.state
    const {
      blockstyle,
      selectedTests,
      markedTests,
      markedReviewTests,
    } = this.state
    const districtShareCheckboxContext = this.getDistrictShareCheckboxContext()
    const bulkCheckboxRule = playlist._id ? 'default' : 'district'
    const markedTestsList = markedTests.map((data) => data._id)
    const markedReviewTestsList = markedReviewTests.map((data) => data._id)
    const readyToReviewTab = this.isReadyToReviewTab()
    const showDistrictBulkToolbar = canShowDistrictBulkToolbar(
      districtShareCheckboxContext
    )
    /** Move-to-District bulk UI only on My Content (Created by me), not Ready tab. */
    const districtBulkMyContentView =
      !playlist._id &&
      filter?.filter === SMART_FILTERS.AUTHORED_BY_ME &&
      !readyToReviewTab &&
      showDistrictBulkToolbar
    const readyTabSelectionView =
      !playlist._id &&
      filter?.filter === SMART_FILTERS.AUTHORED_BY_ME &&
      readyToReviewTab
    const handleCheckboxActionForList = playlist._id
      ? this.handleCheckboxAction
      : readyTabSelectionView
      ? this.handleReviewCheckboxAction
      : districtBulkMyContentView
      ? this.handleCheckboxAction
      : undefined
    const activeMarkedList = readyTabSelectionView
      ? markedReviewTestsList
      : markedTestsList
    const listBulkCheckboxRule = readyTabSelectionView
      ? 'readyToReview'
      : bulkCheckboxRule
    const moduleTitleMap = {}
    const modulesMap =
      playlist?.modules?.map((module) => ({
        title: module.title,
        data: [...module.data.map((it) => it.contentId)],
      })) || []
    const testIds = tests?.map((test) => test._id) || []
    testIds.forEach((testId) => {
      for (const obj of modulesMap) {
        if (obj?.data?.includes(testId)) moduleTitleMap[testId] = obj.title
      }
    })

    const currentSearchFingerprint = getTestListSearchFingerprint(
      this.buildTestSearch(filter)
    )
    const { activeTestListSearchFingerprint } = this.props
    const listMatchesCurrentSearch =
      activeTestListSearchFingerprint === currentSearchFingerprint

    if (!listMatchesCurrentSearch) {
      return <Spin size="large" />
    }
    if (tests.length < 1) {
      if (this.isReadyToReviewTab() && !this.isBulkConversionInProgress()) {
        return (
          <div style={{ marginTop: '10%' }}>
            <ReadyToReviewEmptyState />
          </div>
        )
      }
      const { SEARCH_NO_DATA_SCREEN } = CREATE_AI_TEST_DISPLAY_SCREENS
      return (
        <NoDataContainer margin="190px">
          <FlexContainer flexDirection="column" alignItems="center">
            <NoDataNotification
              wrapperStyle={{ minHeight: '15vh' }}
              style={{ width: 'auto', height: 'auto' }}
              heading={getNoDataTextForFilter(filter, 'test')}
            />
            <EduAIQuiz displayScreen={SEARCH_NO_DATA_SCREEN} />
          </FlexContainer>
        </NoDataContainer>
      )
    }
    const GridCountInARow = getGridCountInARow(windowWidth)
    const countModular = new Array(
      GridCountInARow - (tests.length % GridCountInARow)
    ).fill(1)
    const testSearchFingerprint = currentSearchFingerprint

    if (blockstyle === 'tile') {
      return (
        <Row
          type="flex"
          justify={windowWidth > 575 ? 'space-between' : 'center'}
        >
          <SearchSatisfactionResultsList
            items={tests}
            filter={filter}
            libraryType="test"
            surface="testLibrary"
            viewMode="tile"
            gridCountInARow={GridCountInARow}
            searchFingerprint={testSearchFingerprint}
            renderItem={(item, index) => (
              <CardWrapper
                item={item}
                key={index}
                owner={
                  item.authors && item.authors.some((x) => x._id === userId)
                }
                blockStyle="tile"
                windowWidth={windowWidth}
                history={history}
                match={match}
                interestedStandardIdentifiers={getInterestedStandardIdentifiersFromAlignmentData(
                  {
                    alignment: item.alignment,
                    interestedCurriculums,
                  }
                )}
                setAISuiteAlertModalVisibility={
                  this.setAISuiteAlertModalVisibility
                }
                checked={activeMarkedList.includes(item._id)}
                handleCheckboxAction={handleCheckboxActionForList}
                districtShareCheckboxContext={districtShareCheckboxContext}
                bulkCheckboxRule={listBulkCheckboxRule}
                districtMoveInProgress={
                  districtBulkMyContentView ? movingTestsToDistrict : false
                }
              />
            )}
          />

          {windowWidth > 1024 &&
            countModular.map((index) => <CardBox key={index} />)}
        </Row>
      )
    }

    return (
      <Row>
        <SearchSatisfactionResultsList
          items={tests}
          filter={filter}
          libraryType="test"
          surface="testLibrary"
          viewMode="list"
          searchFingerprint={testSearchFingerprint}
          renderItem={(item) => (
            <CardWrapper
              key={item._id}
              owner={item.authors && item.authors.some((x) => x._id === userId)}
              item={item}
              windowWidth={windowWidth}
              history={history}
              match={match}
              mode={mode}
              removeTestFromPlaylist={this.handleRemoveTest}
              isTestAdded={
                selectedTests ? selectedTests.includes(item._id) : false
              }
              addTestToPlaylist={this.handleAddTests}
              interestedStandardIdentifiers={getInterestedStandardIdentifiersFromAlignmentData(
                {
                  alignment: item.alignment,
                  interestedCurriculums,
                }
              )}
              moduleTitle={moduleTitleMap[item._id]}
              checked={activeMarkedList.includes(item._id)}
              handleCheckboxAction={handleCheckboxActionForList}
              onRemoveFromCart={this.onRemoveFromCart}
              onAddToCart={this.onAddToCart}
              setAISuiteAlertModalVisibility={
                this.setAISuiteAlertModalVisibility
              }
              districtShareCheckboxContext={districtShareCheckboxContext}
              bulkCheckboxRule={listBulkCheckboxRule}
              districtMoveInProgress={
                districtBulkMyContentView ? movingTestsToDistrict : false
              }
            />
          )}
        />
      </Row>
    )
  }

  handleLabelSearch = (e) => {
    const { key: filterType } = e
    const getMatchingObj = getMatchingFilterObjects({
      filterMenuItems,
      filterPath: filterType,
    })
    const { filter = '' } = (getMatchingObj.length && getMatchingObj[0]) || {}
    const { history, limit, playlistPage, playlist: { _id } = {} } = this.props
    const stateFilter = this.state.filter

    let updatedKeys = omit(
      filter === this.state.filter
        ? stateFilter
        : {
            ...produce(emptyFilters, (draft) => {
              return draft
            }),
            ...(filter === SMART_FILTERS.FOLDERS
              ? {}
              : getFilterFromSession({
                  key:
                    sessionFilterKeys[
                      `SEARCH_FILTER_${
                        getMatchingObj[0]?.sessionFilterKey ||
                        getMatchingObj[0]?.filter
                      }`
                    ],
                  districtId: this.props.districtId,
                  userId: this.props.userId,
                })),
          },
      ['folderId']
    )

    if (filter === filterMenuItems[0].filter) {
      updatedKeys = {
        ...updatedKeys,
        status: '',
      }
    }
    const sortByRecency = ['by-me', 'shared', 'co-author'].includes(filterType)
    const sortByRelevance =
      filter === SMART_FILTERS.ENTIRE_LIBRARY &&
      shouldUseRelevanceSortForEntireLibrary(this.props)
    const sort = {
      sortBy: sortByRecency
        ? 'recency'
        : sortByRelevance
        ? 'relevance'
        : 'popularity',
      sortDir: 'desc',
    }
    updatedKeys.filter = filter
    this.updateFilterState(updatedKeys, sort, true)

    const queryParams = qs.stringify(
      pickBy({ ...updatedKeys, page: 1, limit }, identity)
    )
    const locToPush = playlistPage
      ? `/author/playlists/${_id}/edit`
      : `/author/tests?${queryParams}`
    history.push(locToPush)

    if (filterType !== 'folders') {
      this.fetchTests({
        page: 1,
        limit,
        search: updatedKeys,
        sort,
      })
    }
  }

  rejectNumberChecker = (tests) => {
    let num = 0
    for (const o of tests) {
      if (o.status === 'inreview') {
        num++
      }
    }
    return num
  }

  approveNumberChecker = (tests) => {
    let num = 0
    for (const o of tests) {
      if (o.status === 'inreview' || o.status === 'rejected') {
        num++
      }
    }
    return num
  }

  onSelectSortOption = (value, sortDir) => {
    const { limit, sort } = this.props
    const { filter } = this.state
    const updateSort = {
      ...sort,
      sortBy: value,
      sortDir,
    }
    this.updateFilterState(filter, updateSort, true)
    this.fetchTests({
      page: 1,
      limit,
      search: filter,
      sort: updateSort,
    })
  }

  handleApproveTests = () => {
    const {
      approveOrRejectMultipleTestsRequest,
      selectedTests,
      setApproveConfirmationOpen,
    } = this.props
    if (selectedTests.length > 1) {
      setApproveConfirmationOpen(true)
    } else {
      approveOrRejectMultipleTestsRequest({ status: 'published' })
    }
  }

  handleSelectAll = (e) => {
    const { filter } = this.state
    if (filter?.status === 'draft') {
      return
    }
    const { tests = [] } = this.props
    const ctx = this.getDistrictShareCheckboxContext()
    const selectableTests = tests.filter((t) =>
      canShowDistrictShareCheckboxForTest(t, ctx)
    )
    if (e.target.checked) {
      segmentApi.genericEventTrack(
        BULK_CONVERTER_SEGMENT.MOVE_TO_DISTRICT_SELECT_ALL,
        {
          selectableCount: selectableTests.length,
        }
      )
      this.setState({
        markedTests: selectableTests.map((t) => ({
          _id: t._id,
          title: t.title,
        })),
      })
    } else {
      segmentApi.genericEventTrack(
        BULK_CONVERTER_SEGMENT.MOVE_TO_DISTRICT_DESELECT_ALL,
        {
          hadSelection: (this.state.markedTests || []).length > 0,
        }
      )
      this.setState({ markedTests: [] })
    }
  }

  handleMoveToDistrict = () => {
    const { markedTests, filter } = this.state
    if (filter?.status === 'draft') {
      return
    }
    const { tests, moveTestsToDistrictRequest } = this.props
    if (!markedTests?.length) {
      notification({
        type: 'warn',
        msg: 'Select at least one test to move to District Library.',
      })
      return
    }
    const ctx = this.getDistrictShareCheckboxContext()
    const markedIds = markedTests.map((m) => (m._id != null ? m._id : m))
    const eligibleIds = markedIds.filter((id) => {
      const test = tests?.find((t) => t._id === id)
      return test && canShowDistrictShareCheckboxForTest(test, ctx)
    })
    const eligibleIdSet = new Set(eligibleIds)
    const prunedMarkedTests = markedTests.filter((m) => {
      const id = m._id != null ? m._id : m
      return eligibleIdSet.has(id)
    })

    if (eligibleIds.length === 0) {
      if (markedTests.length > 0) {
        this.setState({ markedTests: prunedMarkedTests })
        notification({
          type: 'warn',
          msg:
            'None of the selected tests can be moved to the District Library. Your selection was cleared (tests may not be eligible or are no longer on this page).',
        })
      }
      return
    }

    if (prunedMarkedTests.length !== markedTests.length) {
      this.setState({ markedTests: prunedMarkedTests })
    }

    const moveCount = eligibleIds.length

    AntdModal.confirm({
      title: 'Move to District Library?',
      okText: 'Move',
      cancelText: 'Cancel',
      width: 500,
      content: (
        <div>
          <p>
            You are about to move{' '}
            <strong>
              {moveCount} test{moveCount === 1 ? '' : 's'}
            </strong>{' '}
            to the District Library. Teachers in your district will be able to
            find and use them.
          </p>
        </div>
      ),
      onOk: () => {
        segmentApi.genericEventTrack(
          BULK_CONVERTER_SEGMENT.MOVE_TO_DISTRICT_CONFIRM,
          {
            eligibleCount: eligibleIds.length,
            totalSelected: markedTests.length,
          }
        )
        moveTestsToDistrictRequest({ testIds: eligibleIds })
      },
      onCancel: () => {
        segmentApi.genericEventTrack(
          BULK_CONVERTER_SEGMENT.MOVE_TO_DISTRICT_CANCEL,
          {
            eligibleCount: eligibleIds.length,
            totalSelected: markedTests.length,
          }
        )
      },
    })
  }

  getDistrictSelectableTests = () => {
    const ctx = this.getDistrictShareCheckboxContext()
    return (
      this.props.tests?.filter((test) =>
        canShowDistrictShareCheckboxForTest(test, ctx)
      ) || []
    )
  }

  getDistrictBulkSelectAllChecked = () => {
    const selectable = this.getDistrictSelectableTests()
    const { markedTests } = this.state
    if (selectable.length === 0) return false
    return selectable.every((s) =>
      (markedTests || []).some((m) => (m._id != null ? m._id : m) === s._id)
    )
  }

  renderDistrictBulkSelectAllCheckbox = () => {
    const { filter } = this.state
    const { movingTestsToDistrict } = this.props
    const noDistrictSelectable = this.getDistrictSelectableTests().length === 0
    return (
      <SelectAllLabel>
        <Checkbox
          title="Select to move to district"
          disabled={
            filter.status === 'draft' ||
            movingTestsToDistrict ||
            noDistrictSelectable
          }
          checked={this.getDistrictBulkSelectAllChecked()}
          onChange={this.handleSelectAll}
          data-cy="selectAllTests"
        />
        Select all
      </SelectAllLabel>
    )
  }

  renderDistrictMoveToDistrictButton = () => {
    const { filter, markedTests } = this.state
    const { movingTestsToDistrict } = this.props
    const count = (markedTests || []).length
    const hasSelection = count > 0
    const noDistrictSelectable = this.getDistrictSelectableTests().length === 0
    const primaryActive =
      filter.status !== 'draft' &&
      hasSelection &&
      !movingTestsToDistrict &&
      !noDistrictSelectable
    return (
      <EduButton
        data-cy="moveToDistrictSelected"
        onClick={this.handleMoveToDistrict}
        loading={movingTestsToDistrict}
        disabled={
          filter.status === 'draft' ||
          !hasSelection ||
          movingTestsToDistrict ||
          noDistrictSelectable
        }
        style={{
          background: primaryActive ? themeColor : undefined,
          color: primaryActive ? '#fff' : undefined,
          border: primaryActive ? `1px solid ${themeColor}` : undefined,
        }}
      >
        Move to District
        {hasSelection && !movingTestsToDistrict ? ` (${count})` : ''}
      </EduButton>
    )
  }

  getReviewBulkSelectAllChecked = () => {
    const { tests = [] } = this.props
    const { markedReviewTests } = this.state
    if (tests.length === 0) return false
    return tests.every((t) =>
      (markedReviewTests || []).some(
        (m) => (m._id != null ? m._id : m) === t._id
      )
    )
  }

  handleReviewSelectAll = (e) => {
    const { tests = [] } = this.props
    if (e.target.checked) {
      this.setState({
        markedReviewTests: tests.map((t) => ({ _id: t._id, title: t.title })),
      })
    } else {
      this.setState({ markedReviewTests: [] })
    }
  }

  renderReviewBulkSelectAllCheckbox = () => {
    const { tests = [], clearingReviewRequired } = this.props
    const noSelectable = tests.length === 0
    return (
      <SelectAllLabel>
        <Checkbox
          title="Select all tests ready for review"
          disabled={noSelectable || clearingReviewRequired}
          checked={this.getReviewBulkSelectAllChecked()}
          onChange={this.handleReviewSelectAll}
          data-cy="selectAllReviewTests"
        />
        Select all
      </SelectAllLabel>
    )
  }

  renderMoveContentButton = () => {
    const { clearingReviewRequired } = this.props
    const { markedReviewTests } = this.state
    const count = (markedReviewTests || []).length
    const hasSelection = count > 0
    const primaryActive = hasSelection && !clearingReviewRequired
    return (
      <EduButton
        data-cy="moveContentFromReadyTab"
        disabled={clearingReviewRequired || !hasSelection}
        loading={clearingReviewRequired}
        onClick={this.handleMoveContent}
        style={{
          background: primaryActive ? themeColor : undefined,
          color: primaryActive ? '#fff' : undefined,
          border: primaryActive ? `1px solid ${themeColor}` : undefined,
        }}
      >
        Move Content
        {hasSelection && !clearingReviewRequired ? ` (${count})` : ''}
      </EduButton>
    )
  }

  renderToolbarBulkActions = () => {
    const { isContentConvertEnabled, mode, playlist = {} } = this.props
    const { filter } = this.state

    if (
      !isContentConvertEnabled ||
      playlist._id ||
      mode === 'embedded' ||
      filter?.filter !== SMART_FILTERS.AUTHORED_BY_ME
    ) {
      return null
    }

    if (this.isReadyToReviewTab()) {
      return (
        <BulkActionsCluster data-cy="readyTabBulkActions">
          {this.renderReviewBulkSelectAllCheckbox()}
          {this.renderMoveContentButton()}
        </BulkActionsCluster>
      )
    }

    if (
      !this.isReadyToReviewTab() &&
      canShowDistrictBulkToolbar(this.getDistrictShareCheckboxContext())
    ) {
      return (
        <BulkActionsCluster data-cy="districtBulkActions">
          {this.renderDistrictBulkSelectAllCheckbox()}
          {this.renderDistrictMoveToDistrictButton()}
        </BulkActionsCluster>
      )
    }

    return null
  }

  renderExtra = () => (
    <>
      <FeaturesSwitch inputFeatures="isCurator" actionOnInaccessible="hidden">
        <CartButton
          onClick={() => {
            const { approveOrRejectMultipleTestsRequest } = this.props
            approveOrRejectMultipleTestsRequest({ status: 'rejected' })
          }}
          buttonText="Reject"
          numberChecker={this.rejectNumberChecker}
        />
        <CartButton
          onClick={this.handleApproveTests}
          buttonText="Approve"
          numberChecker={this.approveNumberChecker}
        />
      </FeaturesSwitch>
    </>
  )

  toggleFilter = () => {
    const { isShowFilter } = this.state

    this.setState({
      isShowFilter: !isShowFilter,
    })
  }

  handleCreateTest = () => {
    const { createTestFromCart } = this.props
    createTestFromCart()
  }

  dismissBulkConvertStatusBar = () => {
    const { pdlBulkConversionId } = this.state
    if (pdlBulkConversionId != null) {
      markBulkConversionBannerDismissed(pdlBulkConversionId)
    }
    this.setState({
      pdlBulkStatusBarDismissed: true,
      pdlBulkConversionId: null,
      pdlBulkFromConvert: false,
      pdlBulkConversionDetail: null,
      pdlBulkCsvReadyForDownload: false,
      pdlBulkIncompleteCount: null,
    })
  }

  handleBulkConvertIncompleteCountChange = (count) => {
    this.setState({ pdlBulkIncompleteCount: count })
  }

  clearBulkConvertLocationState = (conversion) => {
    const { history, location, page, limit, sort } = this.props
    const { filter, pdlBulkConversionId: bulkConversionId } = this.state
    if (history?.replace) {
      history.replace({
        pathname: location.pathname,
        search: location.search || '',
        state: bulkConversionId ? { bulkConversionId } : {},
      })
    }
    this.setState({ pdlBulkFromConvert: false })

    if (!conversion) {
      this.setState({
        pdlBulkConversionDetail: null,
        pdlBulkCsvReadyForDownload: false,
      })
      return
    }

    const stillBusy = isConversionBusy(conversion)

    this.setState({
      pdlBulkConversionDetail: conversion,
      pdlBulkCsvReadyForDownload: Boolean(!stillBusy),
    })

    if (!stillBusy) {
      const tabOverride = this.isReadyToReviewTab()
        ? TEST_LIBRARY_TABS.READY_TO_REVIEW
        : undefined
      this.fetchTests({ page, limit, search: filter, sort }, tabOverride)
    }
  }

  render() {
    const {
      page,
      limit,
      count,
      creating,
      mode,
      playlist = {},
      addModuleToPlaylist,
      updateModuleInPlaylist,
      resequenceModules,
      isProxyUser,
      isDemoAccount,
      t,
      sort = {},
      history,
      userRole,
      addTestToCartInProgress,
      features,
      isOrgUser,
      isDistrictUser,
      isContentConvertEnabled,
      activeTestListSearchFingerprint,
      tests,
    } = this.props
    const { filter } = this.state

    const {
      blockstyle,
      isShowFilter,
      showManageModuleModal,
      showAddTestInModules,
      showConfirmRemoveModal,
      showAddModules,
      showRemoveModules,
      markedTests,
      moduleModalAdd,
      testAdded,
      openSidebar,
      isBuyAISuiteAlertModalVisible,
      showRightSideMenu,
      pdlBulkConversionId,
      pdlBulkFromConvert,
      libraryTab,
    } = this.state
    const search = {
      ...filter,
    }
    const readyToReviewTab = this.isReadyToReviewTab()
    const listMatchesCurrentSearch =
      activeTestListSearchFingerprint ===
      getTestListSearchFingerprint(this.buildTestSearch(filter))
    const showReadyToReviewDisclaimer =
      readyToReviewTab && listMatchesCurrentSearch && tests.length > 0

    const showBulkConvertStatusBar =
      isContentConvertEnabled &&
      !playlist._id &&
      filter?.filter === SMART_FILTERS.AUTHORED_BY_ME &&
      mode !== 'embedded' &&
      readyToReviewTab &&
      !this.state.pdlBulkStatusBarDismissed

    let modulesList = []
    if (playlist) {
      modulesList = playlist.modules
    }

    const showStatusFilter =
      ((features.isPublisherAuthor || isOrgUser || isDistrictUser) &&
        filter.filter !== SMART_FILTERS.ENTIRE_LIBRARY) ||
      features.isCurator
    const isPublisher = !!(features.isPublisherAuthor || features.isCurator)
    const statusFilterDataObject = filterData.find(
      (v) => v.onChange === 'status'
    )
    const statusData = [
      ...statusFilterDataObject.data,
      ...(isPublisher ? statusFilterDataObject.publisherOptions : []),
    ]

    const showPdlPostUploadToolbar =
      pdlBulkConversionId &&
      isContentConvertEnabled &&
      !playlist._id &&
      mode !== 'embedded' &&
      filter?.filter === SMART_FILTERS.AUTHORED_BY_ME &&
      readyToReviewTab

    const gradeMeta = filterData.find((v) => v.onChange === 'grades')
    const subjectMeta = filterData.find((v) => v.onChange === 'subject')
    const gradesValue = Array.isArray(filter.grades)
      ? filter.grades
      : filter.grades
      ? [filter.grades]
      : []
    const subjectValue = Array.isArray(filter.subject)
      ? filter.subject
      : filter.subject
      ? [filter.subject]
      : []
    const sortMenuEl = (
      <SortMenu
        options={sortOptions.testList}
        onSelect={this.onSelectSortOption}
        sortDir={sort.sortDir}
        sortBy={sort.sortBy}
      />
    )
    const toolbarBulkActionsEl = this.renderToolbarBulkActions()
    const toolbarRightClusterEl = (
      <ListToolbarRightCluster>
        {toolbarBulkActionsEl}
        {sortMenuEl}
      </ListToolbarRightCluster>
    )

    const menu = (
      <Menu>
        <Menu.Item
          key="0"
          data-cy="addToModule"
          onClick={this.handleBulkAddTests}
        >
          Add to Module
        </Menu.Item>
        <Menu.Item
          key="1"
          data-cy="removeFromModule"
          onClick={this.handleBulkRemoveTests}
        >
          Remove from Modules
        </Menu.Item>
      </Menu>
    )

    const counts = []
    markedTests.forEach(({ _id }) => {
      playlist?.modules?.forEach((module, i) => {
        if (module?.data.map((x) => x.contentId).includes(_id)) {
          if (counts[i]) counts[i]++
          else counts[i] = 1
        }
      })
    })

    const modulesNamesCountMap = counts.map((item, i) => ({
      count: item,
      mName: playlist?.modules[i]?.title,
    }))

    const renderFilterIcon = () => (
      <EduIf condition={isShowFilter}>
        <EduThen>
          <StyledEduButton
            data-cy="smart-filter"
            isGhost={!isShowFilter}
            onClick={this.toggleFilter}
            style={{
              height: '24px',
              marginRight: '10px',
              borderRadius: '15px',
            }}
          >
            <IconFilter width={15} height={15} />
            FILTERS
          </StyledEduButton>
        </EduThen>
        <EduElse>
          <FilterToggleBtn
            isShowFilter={isShowFilter}
            toggleFilter={this.toggleFilter}
          />
        </EduElse>
      </EduIf>
    )

    const { CREATE_TEST_SCREEN } = CREATE_AI_TEST_DISPLAY_SCREENS
    const { searchString, filter: filterCategory } = filter
    const isZoomedView = this.isZoomedView

    return (
      <>
        <Helmet>
          <title>{`Test Library - ${
            page ? `Page ${page}` : ''
          } - ${BASE_TITLE}`}</title>
        </Helmet>
        <EduIf condition={addTestToCartInProgress}>
          <LoaderOverlay>
            <Spin />
          </LoaderOverlay>
        </EduIf>
        <RemoveTestModal
          isVisible={showConfirmRemoveModal}
          onClose={this.onCloseConfirmRemoveModal}
          handleRemove={this.removeTestFromPlaylist}
        />
        {mode !== 'embedded' && (
          <>
            <ListHeader
              renderBanner={
                <FeatureBannerPlaceholder placeholderId="test-library" />
              }
              smallDesktopFlexDirection="row"
              align="center"
              HeaderHeight={{}}
              onCreate={this.handleCreate}
              creating={creating}
              title={t('common.testLibrary')}
              titleIcon={IconTestBank}
              btnTitle="New Test"
              renderFilter={() => (
                <>
                  {isZoomedView ? (
                    <IconHamburger
                      role="button"
                      style={{ cursor: 'pointer' }}
                      onClick={() =>
                        this.setState({ showRightSideMenu: !showRightSideMenu })
                      }
                    />
                  ) : (
                    <>
                      {userRole !== roleuser.EDULASTIC_CURATOR && (
                        <div style={{ marginRight: '5px' }}>
                          <ItemCartButton
                            onClick={this.handleCreateTest}
                            buttonText="New Test"
                            displayDeselect
                            origin="test_library"
                            showBagIcon
                          />
                        </div>
                      )}
                      <StyleChangeWrapper>
                        <LayoutToggleButton
                          aria-label="Grid View"
                          width={18}
                          height={18}
                          tab-index="0"
                          aria-selected={
                            blockstyle === 'tile' ? 'true' : 'false'
                          }
                          $isSelected={blockstyle === 'tile'}
                          onKeyDown={(e) =>
                            onEnterKeyPressHandler(e, () =>
                              this.handleStyleChange('tile')
                            )
                          }
                          onClick={() => this.handleStyleChange('tile')}
                        >
                          <IconTile
                            data-cy="tileView"
                            width={18}
                            height={18}
                            color={
                              blockstyle === 'tile'
                                ? greyThemeDark4
                                : greyThemeLight
                            }
                            aria-hidden="true"
                          />
                          <span
                            style={{ position: 'absolute', left: '-9999px' }}
                          >
                            {blockstyle === 'tile' ? 'Selected' : ''}
                          </span>
                        </LayoutToggleButton>
                        <LayoutToggleButton
                          aria-label="List View"
                          width={18}
                          height={18}
                          tab-index="0"
                          aria-selected={
                            blockstyle === 'horizontal' ? 'true' : 'false'
                          }
                          $isSelected={blockstyle === 'horizontal'}
                          onKeyDown={(e) =>
                            onEnterKeyPressHandler(e, () =>
                              this.handleStyleChange('horizontal')
                            )
                          }
                          onClick={() => this.handleStyleChange('horizontal')}
                        >
                          <IconList
                            data-cy="listView"
                            width={18}
                            height={18}
                            color={
                              blockstyle === 'horizontal'
                                ? greyThemeDark4
                                : greyThemeLight
                            }
                            aria-hidden="true"
                          />
                          <span
                            style={{ position: 'absolute', left: '-9999px' }}
                          >
                            {blockstyle === 'horizontal' ? 'Selected' : ''}
                          </span>
                        </LayoutToggleButton>
                      </StyleChangeWrapper>
                      <EduAIQuiz displayScreen={CREATE_TEST_SCREEN} />
                    </>
                  )}
                </>
              )}
              renderExtra={this.renderExtra}
              toggleSidebar={this.toggleSidebar}
            />
            <SideContent
              onClick={this.toggleSidebar}
              open={openSidebar}
              showSliderBtn={false}
            />
            {showRightSideMenu && (
              <div
                style={{
                  display: 'flex',
                  position: 'fixed',
                  right: '0px',
                  top: '0px',
                  background: 'white',
                  height: '100vh',
                  zIndex: '999',
                  width: '12rem',
                  flexDirection: 'column',
                  justifyContent: 'flex-start',
                  gap: '1rem',
                  alignItems: 'center',
                  borderLeft: `1.5px solid ${greyLight1}`,
                }}
              >
                <>
                  <div
                    style={{
                      display: 'flex',
                      width: 'max-content',
                      alignItems: 'baseline',
                    }}
                  >
                    <h2>Options</h2>
                    <IconClose
                      role="button"
                      style={{ cursor: 'pointer', marginLeft: '1rem' }}
                      onClick={() =>
                        this.setState({ showRightSideMenu: false })
                      }
                    />
                  </div>
                  {userRole !== roleuser.EDULASTIC_CURATOR && (
                    <div>
                      <ItemCartButton
                        onClick={this.handleCreateTest}
                        buttonText="New Test"
                        displayDeselect
                        origin="test_library"
                        showBagIcon
                      />
                    </div>
                  )}
                  <StyleChangeWrapper>
                    <LayoutToggleButton
                      aria-label={`Grid View ${
                        blockstyle === 'tile' ? ',Selected' : ''
                      }`}
                      width={18}
                      height={18}
                      tab-index="0"
                      aria-selected={blockstyle === 'tile' ? 'true' : 'false'}
                      $isSelected={blockstyle === 'tile'}
                      onKeyDown={(e) =>
                        onEnterKeyPressHandler(e, () =>
                          this.handleStyleChange('tile')
                        )
                      }
                      onClick={() => this.handleStyleChange('tile')}
                    >
                      <IconTile
                        data-cy="tileView"
                        width={18}
                        height={18}
                        aria-hidden="true"
                      />
                      <span style={{ position: 'absolute', left: '-9999px' }}>
                        {blockstyle === 'tile' ? 'Selected' : ''}
                      </span>
                    </LayoutToggleButton>
                    <LayoutToggleButton
                      aria-label={`List View ${
                        blockstyle === 'horizontal' ? ',Selected' : ''
                      }`}
                      width={18}
                      height={18}
                      tab-index="0"
                      aria-selected={
                        blockstyle === 'horizontal' ? 'true' : 'false'
                      }
                      $isSelected={blockstyle === 'horizontal'}
                      onKeyDown={(e) =>
                        onEnterKeyPressHandler(e, () =>
                          this.handleStyleChange('horizontal')
                        )
                      }
                      onClick={() => this.handleStyleChange('horizontal')}
                    >
                      <IconList
                        data-cy="listView"
                        width={18}
                        height={18}
                        aria-hidden="true"
                      />
                      <span style={{ position: 'absolute', left: '-9999px' }}>
                        {blockstyle === 'horizontal' ? 'Selected' : ''}
                      </span>
                    </LayoutToggleButton>
                  </StyleChangeWrapper>
                  <EduAIQuiz displayScreen={CREATE_TEST_SCREEN} />
                </>
              </div>
            )}
          </>
        )}
        <Container
          showStatusFilter={showStatusFilter}
          isZoomedView={isZoomedView}
        >
          <MobileFilter>
            <InputTag
              placeholder="Search by title or keywords"
              onSearchInputChange={this.handleSearchInputChange}
              value={searchString}
              disabled={
                filterCategory === libraryFilters.SMART_FILTERS.FAVORITES
              }
              computeSuggestions={(e) => this.computeSuggestions(e)}
              suggestions={this.state.suggestions}
              suggestionKeyWord={this.state.suggestionKeyWord}
              library="test"
            />
            <FilterButton
              aria-label={isShowFilter ? 'Collapse filter' : 'Expand filter'}
            >
              <Button onClick={() => this.toggleFilter()}>
                {!isShowFilter ? 'SHOW FILTERS' : 'HIDE FILTERS'}
              </Button>
            </FilterButton>
          </MobileFilter>
          {isShowFilter && (
            <SearchModalContainer data-cy="searchModal">
              <TestListFilters
                search={search}
                handleLabelSearch={this.handleLabelSearch}
                onChange={this.handleFiltersChange}
                clearFilter={this.handleClearFilter}
                searchFilterOption={this.searchFilterOption}
                filterMenuItems={filterMenuItems}
                isSingaporeMath={this.state.isSingaporeMath}
                libraryFolderExpandedSessionStorageKey={
                  sessionFilters.TEST_LIBRARY_FILTER_EXPANDED
                }
              />
            </SearchModalContainer>
          )}

          {showManageModuleModal && (
            <Modal
              open={showManageModuleModal}
              title="Manage Modules"
              onClose={this.onCloseManageModule}
              footer={null}
              styles={{
                modal: {
                  minWidth: '900px',
                  padding: '20px 30px',
                  background: white,
                },
              }}
            >
              <ManageModulesModalBody
                destinationCurriculumSequence={playlist}
                addModuleToPlaylist={addModuleToPlaylist}
                updateModuleInPlaylist={updateModuleInPlaylist}
                deleteModuleFromPlaylist={this.deleteModule}
                resequenceModules={resequenceModules}
                handleAddModule={this.onCloseCreateModule}
                handleApply={this.handleSaveModule}
                onCloseManageModule={this.onCloseManageModule}
                addState={moduleModalAdd}
                handleTestAdded={this.handleTestAdded}
                testAddedTitle={testAdded?.title}
              />
            </Modal>
          )}

          {showAddTestInModules && (
            <AddTestModal
              isVisible={showAddTestInModules}
              onClose={this.onCloseAddTestModal}
              modulesList={modulesList}
              handleTestAdded={this.handleTestAdded}
            />
          )}

          {showAddModules && (
            <AddBulkTestModal
              isVisible={showAddModules}
              onClose={this.onCloseBulkAddTestModal}
              modulesList={modulesList}
              handleBulkTestAdded={this.handleBulkTestAdded}
            />
          )}

          {showRemoveModules && (
            <DeleteBulkTestModal
              isVisible={showRemoveModules}
              onClose={this.onCloseBulkDeleteTestModal}
              markedTests={markedTests?.length}
              modulesNamesCountMap={modulesNamesCountMap}
              handleBulkTestDelete={this.handleBulkTestDelete}
            />
          )}

          <EduIf condition={isBuyAISuiteAlertModalVisible}>
            <BuyAISuiteAlertModal
              isVisible={isBuyAISuiteAlertModalVisible}
              setAISuiteAlertModalVisibility={
                this.setAISuiteAlertModalVisibility
              }
              history={history}
              isClosable
              stayOnSamePage
            />
          </EduIf>

          <FlexContainer>
            <Filter isShowFilter={isShowFilter}>
              <AffixWrapper isBannerShown={isProxyUser || isDemoAccount}>
                <ScrollbarWrapper isShowFilter={isShowFilter}>
                  <PerfectScrollbar>
                    <ScrollBox>
                      <TestListFilters
                        search={search}
                        handleLabelSearch={this.handleLabelSearch}
                        onChange={this.handleFiltersChange}
                        clearFilter={this.handleClearFilter}
                        searchFilterOption={this.searchFilterOption}
                        filterMenuItems={filterMenuItems}
                        isSingaporeMath={this.state.isSingaporeMath}
                        libraryFolderExpandedSessionStorageKey={
                          sessionFilters.TEST_LIBRARY_FILTER_EXPANDED
                        }
                      />
                    </ScrollBox>
                  </PerfectScrollbar>
                </ScrollbarWrapper>
              </AffixWrapper>
            </Filter>
            <Main isShowFilter={isShowFilter} isZoomedView={isZoomedView}>
              <MainTopStatic>
                <div style={{ padding: '22px 32px 5px 32px' }}>
                  <InputTag
                    onSearchInputChange={this.handleSearchInputChange}
                    size="large"
                    value={searchString}
                    computeSuggestions={(e) => this.computeSuggestions(e)}
                    suggestions={this.state.suggestions}
                    suggestionKeyWord={this.state.suggestionKeyWord}
                    library="test"
                  />
                </div>
                {isContentConvertEnabled &&
                  !playlist._id &&
                  mode !== 'embedded' &&
                  filter?.filter === SMART_FILTERS.AUTHORED_BY_ME && (
                    <div style={{ padding: '8px 32px 0' }}>
                      <TestLibraryTabs
                        activeTab={libraryTab}
                        onChange={this.handleLibraryTabChange}
                      />
                    </div>
                  )}
                {showPdlPostUploadToolbar && (
                  <div style={{ padding: '20px 32px 12px' }}>
                    <PdlBulkPostUploadToolbar
                      grades={gradesValue}
                      subject={subjectValue}
                      gradeOptions={gradeMeta?.data || []}
                      subjectOptions={subjectMeta?.data || []}
                      onGradesChange={(v) =>
                        this.handleFiltersChange('grades', v)
                      }
                      onSubjectChange={(v) =>
                        this.handleFiltersChange('subject', v)
                      }
                      sortSlot={sortMenuEl}
                      bulkActionsSlot={toolbarBulkActionsEl}
                    />
                  </div>
                )}
                {!showPdlPostUploadToolbar && (
                  <>
                    <EduIf condition={!isShowFilter}>
                      {renderFilterIcon()}
                    </EduIf>
                    <ItemsMenu justifyContent="space-between">
                      <EduIf condition={isShowFilter}>
                        {renderFilterIcon()}
                      </EduIf>
                      <PaginationInfo>
                        <span>{count}</span> TESTS MATCH
                      </PaginationInfo>

                      <HeaderFilter
                        search={_.omit(search, [
                          'type',
                          'depthOfKnowledge',
                          'authorDifficulty',
                          'questionType',
                        ])}
                        handleCloseFilter={this.handleFiltersChange}
                        type="test"
                      />
                      {toolbarRightClusterEl}
                      {mode === 'embedded' && (
                        <BtnActionsContainer>
                          <StyledCountText>
                            {
                              playlist.modules?.flatMap(
                                (item) => item?.data || []
                              )?.length
                            }{' '}
                            TESTS SELECTED
                          </StyledCountText>
                          <StyledButton
                            data-cy="createNewItem"
                            type="secondary"
                            size="large"
                            onClick={() => {}}
                          >
                            <Dropdown
                              overlay={menu}
                              trigger={['click']}
                              placement="bottomCenter"
                            >
                              <a
                                data-cy="moduleActions"
                                className="ant-dropdown-link"
                                href="#"
                              >
                                Actions
                              </a>
                            </Dropdown>
                          </StyledButton>
                          <StyledButton
                            data-cy="ManageModules"
                            type="secondary"
                            size="large"
                            onClick={this.handleManageModule}
                          >
                            <span>Manage Modules</span>
                          </StyledButton>
                        </BtnActionsContainer>
                      )}
                      {mode !== 'embedded' && blockstyle === 'horizontal' && (
                        <Actions type="TEST" />
                      )}
                    </ItemsMenu>
                    {showStatusFilter && (
                      <StatusFilterContainer justifyContent="space-between">
                        Status
                        {statusData.map(({ value, text }, index) => (
                          <StatusButton
                            key={index}
                            isHighlighted={filter.status === value}
                            onClick={() =>
                              this.handleFiltersChange('status', value)
                            }
                            data-cy={`status-${text}`}
                          >
                            {text}
                          </StatusButton>
                        ))}
                      </StatusFilterContainer>
                    )}
                  </>
                )}
                {showBulkConvertStatusBar && (
                  <BulkConvertStatusBar
                    showInitially={pdlBulkFromConvert}
                    bulkConversionId={pdlBulkConversionId}
                    conversion={this.state.pdlBulkConversionDetail}
                    csvReadyForDownload={this.state.pdlBulkCsvReadyForDownload}
                    tests={tests}
                    dismissed={this.state.pdlBulkStatusBarDismissed}
                    onComplete={this.clearBulkConvertLocationState}
                    onDismiss={this.dismissBulkConvertStatusBar}
                    onIncompleteCountChange={
                      this.handleBulkConvertIncompleteCountChange
                    }
                  />
                )}
                {showReadyToReviewDisclaimer && (
                  <BulkConvertStatusBarDisclaimer>
                    <b>Review required: AI can make mistakes.</b> Pear uses AI
                    to extract items and generate metadata. Please review for
                    accuracy before use.{' '}
                    <StyledDisclaimerLink
                      href="https://www.peardeck.com/privacy"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Learn more
                    </StyledDisclaimerLink>
                  </BulkConvertStatusBarDisclaimer>
                )}
              </MainTopStatic>
              <MainScrollBody $isZoomedView={isZoomedView}>
                {isZoomedView ? (
                  <CardContainer type={blockstyle}>
                    {this.renderCardContent()}
                    <PaginationWrapper
                      type={blockstyle}
                      current={page}
                      total={count}
                      pageSize={limit}
                      onChange={this.handlePaginationChange}
                      hideOnSinglePage
                    />
                  </CardContainer>
                ) : (
                  <PerfectScrollbar
                    style={{
                      height: '100%',
                      padding: '7.5px 32px',
                    }}
                  >
                    <CardContainer type={blockstyle}>
                      {this.renderCardContent()}
                      <PaginationWrapper
                        type={blockstyle}
                        current={page}
                        total={count}
                        pageSize={limit}
                        onChange={this.handlePaginationChange}
                        hideOnSinglePage
                      />
                    </CardContainer>
                  </PerfectScrollbar>
                )}
              </MainScrollBody>
            </Main>
          </FlexContainer>
          <SelectCollectionModal contentType="TEST" />
          <ApproveConfirmModal contentType="TEST" />
        </Container>
      </>
    )
  }
}

const enhance = compose(
  withWindowSizes,
  withNamespaces('header'),
  withAutoCompleteDict,
  connect(
    (state) => ({
      tests: getTestsSelector(state),
      loading: getTestsLoadingSelector(state),
      activeTestListSearchFingerprint: getActiveTestListSearchFingerprintSelector(
        state
      ),
      page: getTestsPageSelector(state),
      limit: getTestsLimitSelector(state),
      count: getTestsCountSelector(state),
      creating: getTestsCreatingSelector(state),
      curriculums: getCurriculumsListSelector(state),
      defaultGrades: getDefaultGradesSelector(state),
      defaultSubject: getDefaultSubjectSelector(state),
      interestedCurriculums: getInterestedCurriculumsSelector(state),
      interestedGrades: getInterestedGradesSelector(state),
      interestedSubjects: getInterestedSubjectsSelector(state),
      userId: get(state, 'user.user._id', false),
      districtId: getUserOrgId(state),
      user: get(state, 'user.user', false),
      testFilters: getTestsFilterSelector(state),
      features: getUserFeatures(state),
      isProxyUser: isProxyUserSelector(state),
      sort: getSortFilterStateSelector(state),
      selectedTests: getSelectedTestsSelector(state),
      isDemoAccount: isDemoPlaygroundUser(state),
      collections: getCollectionsSelector(state),
      userRole: getUserRole(state),
      addTestToCartInProgress: getIsAddingTestToCartStateSelector(state),
      isOrgUser: isOrganizationDistrictSelector(state),
      isDistrictUser: isDistrictUserSelector(state),
      enableDistrictContentFilter: isDistrictContentFilterEnabledSelector(
        state
      ),
      enableBulkMoveContentToDistrict: isEnableBulkMoveContentToDistrictSelector(
        state
      ),
      isContentConvertEnabled: isContentConvertEnabledSelector(state),
      userSignupStatus: getUserSignupStatusSelector(state),
      isCurator: getIsCurator(state),
      maxSharingLevelAllowed: get(state, 'tests.maxSharingLevelAllowed', 4),
      shouldApplyDistrictLibraryFilter: getShouldApplyDistrictLibraryFilterSelector(
        state
      ),
      movingTestsToDistrict: getMovingTestsToDistrictSelector(state),
      clearingReviewRequired: getClearingReviewRequiredSelector(state),
    }),
    {
      getCurriculums: getDictCurriculumsAction,
      getCurriculumStandards: getDictStandardsForCurriculumAction,
      receiveTests: ({ search, ...rest }) => {
        const _search = {
          ...search,
          standardIds: search?.standardIds?.map((item) => item._id) || [],
        }
        delete _search.type
        delete _search.depthOfKnowledge
        delete _search.authorDifficulty
        delete _search.questionType
        return receiveTestsAction({ search: _search, ...rest })
      },
      addModuleToPlaylist: createNewModuleAction,
      updateModuleInPlaylist: updateModuleAction,
      deleteModuleFromPlaylist: deleteModuleAction,
      resequenceModules: resequenceModulesAction,
      addTestToModule: createTestInModuleAction,
      addTestToModuleInBulk: addTestToModuleInBulkAction,
      deleteTestFromModuleInBulk: deleteTestFromModuleInBulkAction,
      clearDictStandards: clearDictStandardsAction,
      updateDefaultSubject: updateDefaultSubjectAction,
      updateDefaultGrades: updateDefaultGradesAction,
      deleteTestFromPlaylist: removeTestFromPlaylistAction,
      getAllTags: getAllTagsAction,
      updateAllTestFilters: updateAllTestSearchFilterAction,
      clearAllFilters: clearTestFiltersAction,
      addTestToCart: addTestToCartAction,
      removeTestFromCart: removeTestFromCartAction,
      approveOrRejectMultipleTestsRequest: approveOrRejectMultipleTestsRequestAction,
      setApproveConfirmationOpen: setApproveConfirmationOpenAction,
      createTestFromCart: createTestFromCartAction,
      moveTestsToDistrictRequest: moveTestsToDistrictRequestAction,
      clearReviewRequiredRequest: clearReviewRequiredRequestAction,
      clearApplyDistrictLibraryFilter: clearApplyDistrictLibraryFilterAction,
    }
  )
)

export default enhance(TestList)

/** @type {typeof Button} */
const StatusButton = styled(Button)`
  color: ${({ isHighlighted }) => isHighlighted && themeColor};
  background-color: ${({ isHighlighted }) => isHighlighted && '#1ab39514'};
  font-size: 12px;
  font-weight: 600;
  &:focus,
  &:hover {
    color: ${themeColor};
    background-color: #1ab39514;
  }
`

const LayoutToggleButton = styled(Button)`
  box-shadow: none;
  padding: 7px 10px;
  height: 36px;
  border: 1px solid;
  border-color: ${({ $isSelected }) =>
    $isSelected ? accessibilityColors.theme.blue : greyThemeDark1} !important;
  border-radius: 0px;
  background-color: ${({ $isSelected }) =>
    $isSelected ? accessibilityColors.theme.blue : white} !important;

  svg {
    fill: ${({ $isSelected }) =>
      $isSelected ? white : greyThemeDark1} !important;
  }

  &:hover {
    background-color: ${({ $isSelected }) =>
      $isSelected ? accessibilityColors.theme.blueHover : white} !important;
    border-color: ${({ $isSelected }) =>
      $isSelected
        ? accessibilityColors.theme.blueHover
        : greyThemeDark1} !important;
  }

  &:first-child {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    border-right: ${({ $isSelected }) =>
      $isSelected ? `1px solid ${accessibilityColors.theme.blue}` : 'none'};
  }

  &:last-child {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }

  &:focus {
    outline: 2px solid ${accessibilityColors.theme.blueHover};
    outline-offset: 2px;
  }
`
